<template>
  <v-marker :lat-lng="icon">
    <v-icon
      :icon-size="markerType.iconSize"
      :icon-anchor="markerType.iconAnchor"
      :popup-anchor="markerType.popupAnchor"
    >
      <div class="icon">
        <template v-if="!!number">
          <div
            class="icon__number"
            :class="
              popupData && popupData.color ? popupData.color : iconNumberClass
            "
            :style="iconStyle"
          >
            {{ number }}
          </div>
        </template>
        <img
          :src="markerType.iconUrl"
          alt="marker"
          style="position: absolute; z-index: 2;"
          class="icon__marker-image"
        />
        <img
          :src="markerType.shadowUrl"
          alt="shadow"
          class="icon__shadow-image"
        />
      </div>
    </v-icon>
    <vPopup v-if="Object.values(popupData).length > 0">
      <div class="popup">
        <p
          :class="`${popupData.color}--text`"
          class="mt-0 mb-2 font-weight-bold body-2"
        >
          {{ popupData.name }}
        </p>
        <p class="mt-0 mb-0">
          {{ popupData.address }}
        </p>
      </div>
    </vPopup>
  </v-marker>
</template>

<script>
import * as Vue2Leaflet from "vue2-leaflet";
import L from "leaflet";

export default {
  name: "MapMarker",
  components: {
    vMarker: Vue2Leaflet.LMarker,
    vIcon: Vue2Leaflet.LIcon,
    vPopup: Vue2Leaflet.LPopup
  },
  props: {
    icon: {
      type: Array,
      default: () => []
    },
    markerType: {
      type: Object,
      default: () => {}
    },
    number: {
      type: [Number, String],
      default: 0
    },
    popupData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    iconStyle: {
      type: Object,
      default: () => {}
    },
    iconNumberClass: {
      type: String,
      default: "orange--text"
    }
  },
  created() {
    delete L.Icon.Default.prototype._getIconUrl;

    L.Icon.Default.mergeOptions(this.markerType);
  }
};
</script>

<style lang="scss" scoped>
.icon {
  position: relative;
  display: flex;
  justify-content: center;
}

.icon__number {
  color: white;
  font-size: 15px;
  font-family: $font-family-base;
  font-weight: 500;
  position: absolute;
  top: 4px;
  right: 2px;
  z-index: 3;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  margin-top: 0;
  justify-content: center;
  align-items: center;
}

.icon__marker-image {
  position: absolute;
  z-index: 2;
}
.icon__shadow-image {
  position: absolute;
  top: 10px;
  left: 5px;
  z-index: 1;
}
.popup {
  font-family: $font-family-base;
}
</style>
